d
<template>
    <sa-page-layout ref="SaplPostiLettoPianiView" :btnRouterBackVisible="true" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="table-filter">
            <rsa-configurazione-posti-letto-stanze-view-component ref="cmpRsaConfigurazionePostiLettoStanzeView" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @setLinkBack="onSetLinkBack"></rsa-configurazione-posti-letto-stanze-view-component>
        </template>

        <template slot="table-body">
            <rsa-configurazione-posti-letto-letti-list-component ref="cmpRsaConfigurazionePostiLettoLettoList" />
        </template>
    </sa-page-layout>
</template>

<script>
import RsaConfigurazionePostiLettoLettiListComponent from "../components/RsaConfigurazionePostiLettoLettiListComponent.vue";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazionePostiLettoStanzeViewComponent from "../components/RsaConfigurazionePostiLettoStanzeViewComponent.vue";
/* import RsaConfigurazionePostiLettoLettiEditComponent from "../components/RsaConfigurazionePostiLettoLettiEditComponent.vue";
 */
export default {
    components: { SaPageLayout, RsaConfigurazionePostiLettoStanzeViewComponent, RsaConfigurazionePostiLettoLettiListComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsaprofililis",
            jsonData: {},
            id: "",
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            // console.log("id preso dal mounted", me.id);

            me.$refs.cmpRsaConfigurazionePostiLettoStanzeView.loadData(me.id);
            me.$refs.cmpRsaConfigurazionePostiLettoLettoList.init(me.id);
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onSetLinkBack(id) {
            let me = this;
            me.linkback = "/rsaconfigurazionepostilettopiani/view/" + id;
            //me.linkback = "/configurazioni/rsaconfigurazionepostilettopiani";
        },
    },
};
</script>

<style></style>
